import angular from 'angular';

class impersonateUserModalCtrl {
    /* @ngInject */
    constructor() {}

    $onInit() {
        this.modalUser = this.resolve.modalUser;
        this.componentsUrls = this.resolve.componentsUrls;
        this.modalUserFrom = this.resolve.modalUserFrom;
    }

    copyToClipboard(dataToCopy) {
        navigator.clipboard.writeText(dataToCopy).then();
    }

    close() {
        this.modalInstance.dismiss();
    }
}

angular.module('app.kissuser').component('impersonateUserModal', {
    templateUrl: require('./impersonate-user-modal.html'),
    controller: impersonateUserModalCtrl,
    bindings: {
        modalInstance: '<',
        resolve: '<',
    },
});
